import { h } from 'preact';
import register from '@wcd/preact-custom-element';
import { useEffect, useState } from 'preact/hooks';

const locales = {
  GB: '/',
  IE: '/en-ie/',
  US: '/en-us/',
  CA: '/en-ca/',
  AU: '/en-au/',
  NZ: '/en-nz/',
};

const getCookie = (name) => {
  const cookie = document.cookie.split(';').find((item) => item.trim().startsWith(`${name}=`));
  return cookie && cookie.split('=')[1];
};

export const CountrySelector = () => {
  const [country, setCountry] = useState('');
  const [rdp, setRdp] = useState('');

  const selectCountry = (e) => {
    const {
      target: { value: siteCountry },
    } = e;
    
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-TslAuthJwt': getCookie('TESCookieV2') || '',
      'X-CSRF-Token': getCookie('csrf') || '',
      'X-Requested-With': 'XMLHttpRequest',
    };

    fetch('/api/authn/change-site-country', {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({ siteCountry }),
      headers,
    });

    const cookieDomain = window.document.domain.replace('www.', '.');
    document.cookie = `siteCountry=${siteCountry}; path=/; expires=63072000; domain: ${cookieDomain}`;
    window.location.href = `${locales[siteCountry]}${rdp}`;
  };

  useEffect(() => {
    const pathElements = window.location.pathname.split('/').slice(1);
    const match = pathElements[0].match(/en-(ie|us|ca|au|nz)/i);
    if (match) {
      const [, country] = match;
      setRdp(pathElements.slice(1).join('/'));
      setCountry(country.toLowerCase());
    } else {
      setRdp(pathElements.join('/'));
      setCountry('gb');
    }
  }, []);

  if (!country) {
    return;
  }

  return (
    <select
      onChange={selectCountry}
      data-country={country}
      className="js-country-selector footer-nav__country-selector"
      name="siteCountry"
    >
      <option value="GB" selected={country === 'gb'} data-hreflang="en-gb">
        United Kingdom
      </option>
      <option value="US" selected={country === 'us'} data-hreflang="en-us">
        United States
      </option>
      <option value="AU" selected={country === 'au'} data-hreflang="en-au">
        Australia
      </option>
      <option value="IE" selected={country === 'ie'} data-hreflang="en-ie">
        Ireland
      </option>
      <option value="CA" selected={country === 'ca'} data-hreflang="en-ca">
        Canada
      </option>
      <option value="NZ" selected={country === 'nz'} data-hreflang="en-nz">
        New Zealand
      </option>
    </select>
  );
};

register(CountrySelector, 'tes-country-selector', [], { shadow: false });
